import React from 'react';
import { Header, Panel } from 'rsuite';
import PageContainer from '../components/PageContainer';

export default function UnauthorizedPage() {
  return (
    <PageContainer
      title="XML-Morph"
      header={<Header />}
    >
      <Panel header={<h4>Error</h4>} bordered>
        <div>You are unauthorized.</div>
      </Panel>
    </PageContainer>
  );
}
